import CssBaseline from "@mui/material/CssBaseline";
import {
  BrowserRouter,
  Routes,
  Route,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import Cart from "./pages/cart";
import Checkout from "./pages/checkout";
import CheckoutFinish from "./pages/checkout/finish";
import OrderList from "./pages/order/orderList";
import OrderDetail from "./pages/order/orderDetail";
import OrderCancelSuccess from "./pages/order/orderCancelSuccess";
import AfterSales from "./pages/afterSales";
import ReturnList from "./pages/afterSales/returnList";
import Login from "./pages/login";
import NotFound from "./pages/notFound";
import Demo from "./pages/demo";

import Profile from "./pages/profile";
import ProfileList from "./pages/profile/profileList";
import WishList from "./pages/profile/wishList";
import Reviews from "./pages/profile/reviews";
import WaitingReviewDetail from "./pages/profile/reviews/WaitingReviewDetail";
import ReviewResult from "./pages/profile/reviews/reviewResult";
import BrowsingHistory from "./pages/profile/browsingHistory";
import ShippingAddress from "./pages/profile/address";
import Voucher from "./pages/profile/voucher";
import ForgotPassword from "./pages/profile/ForgotPassword";
import ForgotPasswordSuccess from "./pages/profile/ForgotPassword/components/successDom";
import { useEffect } from "react";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import InvitePolitelyPage from "./pages/profile/invite-a-friend";
import EmailUnsubscribe from "./pages/profile/unsubscribe";
import ProtectedRoute from "@/app/csr-src/utils/ProtectedRoute";
import JDLogin from "@/app/csr-src/pages/login/jdLogin/index";
import { SEO } from "./components/tabTitle/SEO";

const Root = () => {
  useEffect(() => {
    getUserUUIDFromCookie();
  }, []);

  return (
    <CssBaseline>
      <Routes>
        {/* 购物车 */}
        <Route
          path="/Cart"
          element={
            <>
              <SEO title="JoyBuy | Shopping Cart" description="this is shopping cart" />
              <Cart />
            </>
          }
        />
        {/* 结算 */}
        <Route
          path="/Checkout"
          element={
            <ProtectedRoute>
              <SEO title="JoyBuy | Place Your Order" description="checkout please" />
              <Checkout />
            </ProtectedRoute>
          }
        />
        <Route path="/Checkout/finish/:id/:payMethod/:orderId" element={<CheckoutFinish />} />
        {/* 订单详情 */}
        <Route
          path="/profile/my-orders/order-details"
          element={
            <ProtectedRoute>
              <SEO title="JoyBuy | Order Detail" description="this is order detail" />
              <OrderDetail />
            </ProtectedRoute>
          }
        />
        {/* 取消成功页面 */}
        <Route
          path="/order-cancelled"
          element={
            <>
              <SEO title="JoyBuy | Order Canceled" description="order has been canceled" />
              <OrderCancelSuccess />
            </>
          }
        />
        {/* 售后详情 */}
        <Route
          path="/my-orders/refund"
          element={
            <ProtectedRoute>
              <SEO title="JoyBuy | AfterSales" description="Aftersales" />
              <AfterSales />
            </ProtectedRoute>
          }
        />
        {/* 示例 */}
        <Route path="/Demo" element={<Demo />} />

        {/* 个人中心 */}
        <Route
          path="/Profile"
          element={
            <ProtectedRoute>
              <SEO title="JoyBuy | Profile" description="this is your profile" />
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          element={
            <ProtectedRoute>
              <ProfileList />
            </ProtectedRoute>
          }
        >
          {/* 订单 */}
          <Route path="/profile/my-orders" element={<OrderList />} />
          {/* 售后单列表 */}
          <Route path="/profile/my-returns" element={<ReturnList />} />
          {/* 心愿单 */}
          <Route path="/profile/wishlist" element={<WishList />} />
          {/* 历史记录 */}
          <Route path="/profile/shopping-activity" element={<BrowsingHistory />} />
          {/* 收货地址 */}
          <Route path="/profile/my-address" element={<ShippingAddress />} />
          {/* 优惠券列表 */}
          <Route path="/profile/coupons-discounts" element={<Voucher />} />
          {/* 评论列表 */}
          <Route path="/profile/my-reviews" element={<Reviews />} />
        </Route>
        {/* 评论详情 */}
        <Route
          path="/Review"
          element={
            <ProtectedRoute>
              <WaitingReviewDetail />
            </ProtectedRoute>
          }
        />
        {/* 评论结果页面 */}
        <Route
          path="/ReviewResult"
          element={
            <ProtectedRoute>
              <ReviewResult />
            </ProtectedRoute>
          }
        />
        {/* 优惠券列表 */}
        <Route
          path="/profile/coupons-discounts"
          element={
            <ProtectedRoute>
              <Voucher />
            </ProtectedRoute>
          }
        />
        {/* 邀请有礼 */}
        <Route path="/profile/invite-a-friend" element={<InvitePolitelyPage />} />
        {/* 邮件退订 */}
        <Route path="/profile/unsubscribe" element={<EmailUnsubscribe />} />
        {/* 重置密码 */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/password-changed" element={<ForgotPasswordSuccess />} />
        {/* 登录 */}
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
        {/* 京东账号登录中间页 */}
        <Route path="/jd-auth-redirect" element={<JDLogin />} />
      </Routes>
    </CssBaseline>
  );
};

const router = createBrowserRouter([{ path: "*", element: <Root /> }]);
export default function App() {
  return <RouterProvider router={router} />;
}
